import { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import auth from '../../../config/utils/auth';
import { Box, CircularProgress, List, ListItemButton, ListItemText, Typography } from '@mui/material';

export default function SmartyTab({ orderId }) {
  const [images, setImages] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  const authHeaders = useMemo(() => ({ Authorization: 'Bearer ' + auth.getToken() }), []);

  const fetchImages = useCallback(() => {
    if (!orderId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .get(`/api/v1/orders/bsh/${orderId}/smarty_images/`, { headers: authHeaders })
      .then((res) => setImages(res.data || []))
      .catch(() => setImages([]))
      .finally(() => setLoading(false));
  }, [orderId, authHeaders]);

  useEffect(() => {
    fetchImages();
  }, [fetchImages]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 400 }}>
        <CircularProgress />
      </Box>
    );
  }

  const selectedImage = selectedIndex !== null ? images[selectedIndex] : null;

  return (
    <Box sx={{ display: 'flex', height: '100%', minHeight: 400 }}>
      <Box sx={{ width: 240, borderRight: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column' }}>
        <List dense sx={{ flex: 1, overflow: 'auto' }}>
          {images.map((img, index) => (
            <ListItemButton key={img.id} selected={selectedIndex === index} onClick={() => setSelectedIndex(index)}>
              <ListItemText
                primary={`Smarty #${img.id}`}
                secondary={new Date(img.timestamp).toLocaleString()}
                primaryTypographyProps={{ variant: 'body2' }}
                secondaryTypographyProps={{ variant: 'caption' }}
              />
            </ListItemButton>
          ))}
          {!images.length && (
            <Typography variant="body2" sx={{ p: 2, color: 'text.secondary', textAlign: 'center' }}>
              No images
            </Typography>
          )}
        </List>
      </Box>

      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', p: 1 }}>
        {selectedImage ? (
          <img src={selectedImage.url} alt={`Smarty #${selectedImage.id}`} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
        ) : (
          <Typography variant="body2" color="text.secondary">
            {images.length ? 'Select an image from the list' : 'No smarty images available'}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
